export const routePaths = {
  root: '/',
  auth: {
    root: '/auth',
    login: '/auth/login',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password'
  },
  app: {
    root: '/app',
    dashboard: '/app/dashboard',
    gettingStarted: '/app/getting-started',
    patients: '/app/patients',
    patientQuickAdd: '/app/patients/quick-add',
    patientNew: '/app/patients/new',
    patientDetails: '/app/patients/:patientId',
    patientHistory: '/app/patients/:patientId/history',
    patientEdit: '/app/patients/:patientId/edit',
    schedule: '/app/schedule',
    scheduleNew: '/app/schedule/new',
    invoices: '/app/invoices',
    invoiceNew: '/app/invoices/new',
    invoiceEdit: '/app/invoices/:invoiceId/edit',
    masters: '/app/masters',
    mastersMenu: '/app/masters/menu',
    mastersDoctors: '/app/masters/doctors',
    mastersProcedures: '/app/masters/procedures',
    mastersAppointmentTypes: '/app/masters/appointment-types',
    adminMenu: '/app/admin/menu',
    adminClinicProfile: '/app/admin/clinic-profile',
    adminImport: '/app/admin/imports',
    adminRoles: '/app/admin/roles',
    adminRoleNew: '/app/admin/roles/new',
    adminRoleDetails: '/app/admin/roles/:role',
    adminNotificationDeliveries: '/app/admin/notification-deliveries',
    adminUsers: '/app/admin/users',
    reports: '/app/reports',
    reportMetric: '/app/reports/:metric',
    assistant: '/app/assistant',
    profile: '/app/profile',
    owner: '/app/owner',
    errors: '/app/errors',
    systemHealth: '/app/system-health'
  }
} as const;
